import React, { useContext } from "react";
import "./Services.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import Hopping from '../../img/hopping.png'
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import Resume from './resume.pdf';

const Services = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };

  return (
    <div className="services" id="services">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span style={{ color: darkMode ? "white" : "" }}>My soft Skills</span>
        <span>services</span>
        <spane>
          Coding skills of course are the most important part of the job
          <br />
          but you can't make a project without a personality
        </spane>
        <a href={Resume} download>
          <button className="button s-button">Download CV</button>
        </a>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ right: "-28rem" }}
          transition={transition}
        >
          <Card
            emoji={HeartEmoji}
            heading={"Disciplined"}
            detail={"I keep pushing myself to always learn and progress."}
          />
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "2rem", top: "0" }}
          whileInView={{ left: "8rem" }}
          transition={transition}
        >
          <Card
            emoji={Glasses}
            heading={"Proactive"}
            detail={"High responsiveness and dynamism"}
          />
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "19rem", left: "25rem" }}
          whileInView={{ left: "8rem" }}
          transition={transition}
        >
          <Card
            emoji={Humble}
            heading={"Team Work"}
            detail={
              "Great ability to work in a team and create good working relationships"
            }
            color="rgba(252, 166, 31, 0.45)"
          />
        </motion.div>

          {/* 4th  */}
          <motion.div
          initial={{ top: "19rem", right: "21rem" }}
          whileInView={{ right: "-25rem" }}
          transition={transition}
        >
          <Card
            emoji={Hopping}
            heading={"Critical Thinking"}
            detail={
              "Thinking outside the box and being creative, sometimes is better"
            }
            color="rgba(252, 166, 31, 0.45)"
          />
        </motion.div>
       

        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        >
          
        </div>
      </div>
    </div>
  );
};

export default Services;
